import './index.scss';
import applyCountdown from 'utils/countdown';
import { Application, Controller } from 'stimulus';
import { FREE_ACCESS_TEXT, benefits } from './benefits';
import { MediaQuery } from 'utils/media_query';
import { handleApiError } from 'utils/api_error_handler';
import { pluralize } from 'utils/pluralize';
import { saveAs } from 'file-saver';

const isMobile = MediaQuery.is('lt_md');

class ExperimentBenefits extends Controller {
  $benefitPanelBody = $('.q-benefits-panel-body');
  $benefitPanelFooter = $('.q-benefits-panel-footer');
  $benefitWeeklyInformation = $('.q-benefits-weekly-information');

  isMainContentVisible = true;
  isPanelOpen = false;
  $weeklyModal = $('.q-benefits-weekly-modal');

  constructor() {
    super();

    if (!window.currentUser) {
      return;
    }

    this.localStorageKey = `benefitsBalloonVisualized.${window.currentUser.id}`;

    this.addDocumentClickListener();
    this.addClickListeners();

    if (this.canShowBalloon()) {
      this.openBalloon();
    }

    window.notifyExperimentBenefits = this.showBenefitsFloatbutton.bind(this);
    window.callBenefitsWeeklyModal = this.handleBenefitsWeeklyModal.bind(this);
    window.updateBenefitsStudyDays = this.updateBenefitsStudyDays.bind(this);
  }

  canShowBalloon() {
    const isFeatureOn = gon.flags.topbar_benefits.topbar_alert;

    return isFeatureOn && !window.localStorage.getItem(this.localStorageKey);
  }

  addClickListeners() {
    $('.q-benefits-balloon .balloon-button, .q-benefits-button').on(
      'click',
      () => {
        this.closeBalloon();
        this.openPanel();

        UserTracker.emit('event', {
          eventName: 'benefits topbar clicked'
        });
      }
    );

    $('.q-benefits-close').on('click', () => {
      this.closeBalloon();
      this.closePanel();
    });
  }

  addDocumentClickListener() {
    $(document).on('click', event => {
      const iconEl = $('.q-benefits-button');
      const panelBenefitsEl = $('.q-benefits-panel');
      const balloonButtonEl = $('.q-benefits-balloon .balloon-button');

      if (!this.elementIsNotClicked(balloonButtonEl)) {
        event.preventDefault();
        return;
      }

      if (this.elementIsNotClicked(iconEl)) {
        if (this.elementIsNotClicked(panelBenefitsEl) && this.isPanelOpen) {
          this.closePanel();
          this.showMainContent();
        }
      }
    });
  }

  elementIsNotClicked(element) {
    return !element.is(event.target) && element.has(event.target).length === 0;
  }

  openBalloon() {
    $('.q-benefits-balloon').show();
    $('.q-benefits-overlay').show();

    if (isMobile) {
      $('body').addClass('q-no-scroll');
    }
  }

  closeBalloon() {
    $('.q-benefits-balloon').hide();
    $('.q-benefits-overlay').hide();

    if (isMobile) {
      $('body').removeClass('q-no-scroll');
    }

    window.localStorage.setItem(this.localStorageKey, true);
  }

  openPanel() {
    this.isPanelOpen = true;
    $('.q-benefits-panel').show();
    $('.q-benefits-overlay').show();

    this.startPanelLoading();

    Thor.User.used_resources_summary({ user_id: currentUser.id }, {})
      .then(({ summary, day_streak, flag_content }) => {
        const { weekdays, number_of_days, current_day } = day_streak;

        const { info, tooltip } = flag_content;

        const { studied_today } = summary;

        this.updateBenefits(summary);
        this.updateRenewCountdown(summary);
        this.updateDays(weekdays, number_of_days, studied_today, current_day);
        this.updateTopbarButton(number_of_days, studied_today);

        const weekCompleted = Object.values(weekdays).every(day => day);

        this.updateTexts(number_of_days, info, tooltip);
        this.updateSubtitleText(number_of_days, studied_today, weekCompleted);
        this.updateDashboard(day_streak);

        if (weekCompleted) {
          this.animateWeekdays(weekdays);
          this.showDownloadButton();
        }
      })
      .catch(error => {
        handleApiError(
          '[front] Unable to open experiment_benefits panel',
          error?.response ?? error
        );
        this.closePanel();
      })
      .finally(() => {
        this.stopPanelLoading();
      });
  }

  showDownloadButton() {
    $('.q-benefits-panel-footer-download')
      .removeClass('hidden')
      .off('click')
      .on('click', ({ currentTarget }) => {
        saveAs(
          currentTarget.dataset.download,
          'Conquista - Semana Inteira de Estudos'
        );
      });
  }

  updateDashboard(day_streak) {
    const { number_of_days, highscore, extra_life } = day_streak;

    this.updateDashboardItem('.item-info--sequence', number_of_days);
    this.updateDashboardItem('.item-info--highscore', highscore);
    this.updateDashboardItem('.item-info--rest', extra_life);
  }

  updateDashboardItem(selector, value) {
    if (value > 0) {
      $(selector).addClass('item-info--filled');
      $(`${selector} strong`).text(pluralize('dia', value));
    }
  }

  startPanelLoading() {
    $('.q-benefits-panel').addClass('q-benefits-panel--loading');
  }

  stopPanelLoading() {
    $('.q-benefits-panel').removeClass('q-benefits-panel--loading');
  }

  closePanel() {
    this.isPanelOpen = false;
    $('.q-benefits-panel').hide();
    $('.q-benefits-overlay').hide();
  }

  updateTopbarButton(number_of_days, studyToday) {
    const $topbarButtonContainer = $('.q-benefits .q-benefits-button');

    if ($topbarButtonContainer) {
      const $topbarButtonDays = $topbarButtonContainer.find('.days-amount');
      const $iconEl = $topbarButtonContainer.find('.q-icon');

      if (studyToday) {
        $topbarButtonContainer.addClass('q-benefits-button-studied');
        $iconEl.removeClass('q-icon-fire-streak-light');
        $iconEl.addClass('q-icon-fire-streak');
      }

      let contentHtml = `${number_of_days} dias`;

      if (number_of_days === 1) {
        contentHtml = `${number_of_days} dia`;
      }

      $topbarButtonDays.html(contentHtml);
    }
  }

  updateTexts(numberOfDays, textInfo, textTooltip) {
    const $subtitleEl = $(
      '.q-benefits-panel .q-benefits-panel-footer-text-description'
    );
    const $titleEl = $(
      '.q-benefits-panel .q-benefits-panel-footer-text-title .sufix-title'
    );

    const $flagTooltipContainerEl = $(
      '.q-benefits-weekly-information .q-flag-tooltip-container'
    );

    if (numberOfDays === 0) {
      $titleEl.html(textInfo.title);
    }

    $subtitleEl.html(textInfo.subtitle);
    $flagTooltipContainerEl.html(textTooltip);
  }

  updateSubtitleText(numberOfDays) {
    const $titleEl = $(
      '.q-benefits-panel .q-benefits-panel-footer-text-title .sufix-title'
    );
    const $daysAmountEl = $(
      '.q-benefits-panel .q-benefits-panel-footer-text-title .featured'
    );

    let contentHtml = `${numberOfDays} dias`;

    if (numberOfDays === 1) {
      contentHtml = `${numberOfDays} dia`;
    }

    if (numberOfDays >= 1) {
      const studiedTitle = `${numberOfDays === 1 ? 'seguido' : 'seguidos'} de ${
        numberOfDays === 1 ? 'estudo' : 'estudos'
      }`;

      $titleEl.html(studiedTitle);

      $daysAmountEl.find('.text-content').html(contentHtml);

      $daysAmountEl.removeClass('hidden');
    }
  }

  updateDays(weekdays, numberOfDays, studiedToday, currentDay) {
    const $weekdaysContainer = $('.q-benefits-panel .days-list');
    const $streakDayNumber = $('.q-benefits-panel .benefits-streak-total-days');

    const orderedWeekdays = {
      seg: weekdays.seg,
      ter: weekdays.ter,
      qua: weekdays.qua,
      qui: weekdays.qui,
      sex: weekdays.sex,
      sab: weekdays.sab,
      dom: weekdays.dom
    };

    $streakDayNumber.each(function () {
      $(this).closest('.featured').removeClass('animated');
    });

    let weekdaysListHTML = '';

    if ($weekdaysContainer) {
      for (let dayKey in orderedWeekdays) {
        weekdaysListHTML += `
          <li class="q-benefits-day
            ${weekdays[dayKey] ? 'q-benefits-day--studied' : ''}
            ${
              this.isCurrentDay(dayKey, currentDay)
                ? 'q-benefits-day--currentDay'
                : ''
            }
          ">
            <span>${dayKey}</span>
            <div class="icon-background">
              <i class="q-icon ${
                weekdays[dayKey]
                  ? 'q-icon-check-circle-solid'
                  : 'q-icon-moon-stars-solid'
              }"></i>
            </div>
          </li>
        `;
      }

      $weekdaysContainer.html(weekdaysListHTML);
    }

    if (studiedToday) {
      $streakDayNumber.each(function () {
        $(this).closest('.featured').addClass('animated');
      });
    }

    $streakDayNumber.html(numberOfDays);
  }

  isCurrentDay(day, currentDay) {
    const currentDayMapping = {
      Monday: 'seg',
      Tuesday: 'ter',
      Wednesday: 'qua',
      Thursday: 'qui',
      Friday: 'sex',
      Saturday: 'sab',
      Sunday: 'dom'
    };

    return currentDayMapping[currentDay] === day;
  }

  animateWeekdays() {
    const $weekdaysDays = $('.q-benefits-panel .days-list > li');

    const intervalValue = 350;

    let currentInterval = 0;

    $weekdaysDays.each(function () {
      const $iconEl = $(this).find('.q-icon');

      setTimeout(() => {
        $(this).addClass('q-benefits-day--week-complete');

        $iconEl.addClass('q-icon-fire-streak');
      }, currentInterval);

      currentInterval += intervalValue;
    });
  }

  updateRenewCountdown(summary) {
    const { show_renew_countdown } = summary;
    const plansWithCountdown = ['standard', 'advanced'];

    if (
      show_renew_countdown &&
      plansWithCountdown.includes(window.currentUser.publicLevel)
    ) {
      applyCountdown({
        selector: '.q-benefits-panel .countdown-place',
        template: '%H:%M:%S'
      });
    }
  }

  updateBenefits(summary) {
    const level = currentUser.publicLevel;

    const freeLayoutFlag = gon?.flags?.elite_locked_topbar;
    const isFreeLayoutActive = freeLayoutFlag?.active ?? false;
    const useNewStandardLayout = level === 'standard' && isFreeLayoutActive;

    if (useNewStandardLayout) {
      const available = [
        {
          type: 'counter',
          title: 'Questões',
          subtitle: 'Limite diário',
          resource: 'answers',
          icon: 'ballot-check-solid',
          link: '[portal]/questoes-de-concursos/questoes?has_commentaries=true&has_professor_commentaries=true'
        },
        {
          type: 'counter',
          title: 'Comentários',
          subtitle: 'Limite diário',
          resource: 'comments',
          icon: 'comments-solid',
          link: '[portal]/questoes-de-concursos/questoes?has_commentaries=true&has_professor_commentaries=true'
        },
        {
          type: 'counter',
          title: 'Aulas Apostila',
          subtitle: 'Limite diário',
          resource: 'valhalla',
          icon: 'graduation-cap-solid',
          link: '[ils]b/guia-de-estudos/busca/pdf'
        },
        {
          type: 'benefit',
          title: 'Estatísticas',
          icon: 'chart-bar-solid',
          link: '[portal]/questoes-de-concursos/questoes?has_commentaries=true&has_professor_commentaries=true'
        }
      ];

      const exclusives = [
        {
          type: 'blocked',
          title: 'Sessão Desabafo',
          subtitle:
            'Compartilhe suas dificuldades e receba apoio da comunidade Elite',
          link: '[portal]/l/conheca-o-plano-ilimitado-elite',
          level: 'unlimited_qc'
        },
        {
          type: 'blocked',
          title: 'Ranking Elite',
          subtitle: 'Compare seu desempenho com os melhores estudantes',
          link: '[portal]/l/conheca-o-plano-ilimitado-elite',
          level: 'unlimited_qc'
        },
        {
          type: 'blocked',
          title: 'Mini Simulados',
          subtitle: 'Simulados personalizados para testar seu conhecimento',
          link: '[portal]/l/conheca-o-plano-ilimitado-elite',
          level: 'unlimited_qc'
        },
        {
          type: 'blocked',
          title: 'Mentoria Definitiva',
          subtitle: 'Encontros com especialistas para guiar sua preparação.',
          link: '[portal]/l/conheca-o-plano-ilimitado-elite',
          level: 'unlimited_qc'
        }
      ];

      const availableHtml = available
        .map(benefit => {
          const resource = summary.resources[benefit.resource];

          if (benefit.type === 'counter' && benefit.resource && resource) {
            if (resource.threshold <= 20) {
              return this.mountCounterBenefitHtml(benefit, resource, summary);
            }
            return this.mountBenefitHtml(benefit);
          }
          return this.mountBenefitHtml(benefit);
        })
        .join('');

      const exclusivesHtml =
        this.mountDividerHtml('RECURSOS EXCLUSIVOS') +
        this.mountSectionHeaderHtml(
          'Desbloqueie no Plano Elite',
          'Veja o que você está perdendo e leve seus estudos ao próximo nível'
        ) +
        exclusives.map(b => this.mountBlockedBenefitHtml(b)).join('') +
        this.mountEliteFooterLinkHtml();

      $('.q-benefits-panel .benefit-list').html(availableHtml + exclusivesHtml);
      this.bindBenefitClicks();
      return;
    }

    const html = benefits[level].map(benefit => {
      const resource = summary.resources[benefit.resource];

      if (benefit.type === 'counter' && benefit.resource && resource) {
        if (resource.threshold <= 20) {
          return this.mountCounterBenefitHtml(benefit, resource, summary);
        }

        return this.mountBenefitHtml(benefit);
      }

      if (benefit.type === 'blocked') {
        return this.mountBlockedBenefitHtml(benefit);
      }

      return this.mountBenefitHtml(benefit);
    });

    $('.q-benefits-panel .benefit-list').html(html);
    this.bindBenefitClicks();
  }

  mountDividerHtml(text) {
    return `<li class="benefit-list__divider">${text}</li>`;
  }

  mountSectionHeaderHtml(title, subtitle) {
    return `<li class="benefit-list__section">
      <h3><i class="q-icon q-icon-trophy-solid"></i>${title}</h3>
      <p>${subtitle}</p>
    </li>`;
  }

  bindBenefitClicks() {
    const $list = $('.q-benefits-panel .benefit-list');
    $list.off('click', '[data-link]');
    $list.on('click', '[data-link]', event => {
      const link = event.currentTarget.dataset.link;
      const ilsPath = $('.q-benefits-panel').eq(0).data('ils-path');

      if (link.includes('[portal]')) {
        window.location.href = link.replace('[portal]', '');
      } else {
        window.location.href = link.replace('[ils]', ilsPath);
      }
    });
  }

  mountCounterBenefitHtml(
    benefit,
    resource,
    { renew_date, show_renew_countdown }
  ) {
    return `<li class="benefit-list__item" ${
      benefit.link ? `data-link="${benefit.link}"` : ''
    }>
      <div
        class="benefit-list__item__counter"
        role="progressbar"
        aria-valuenow="${resource.remaining_percentage}"
        aria-valuemin="0"
        aria-valuemax="100"
        style="--value: ${resource.remaining_percentage}"
      >
        <p>${resource.remaining}</p>
      </div>

      <div class="benefit-list__item__info">
        <p><strong>${benefit.title}</strong></p>
        <p>
          ${
            show_renew_countdown && resource.remaining === 0
              ? `Limite renovado em <strong class="countdown-place" data-value="${renew_date}"></strong>`
              : `${benefit.subtitle}: ${resource.threshold}`
          }
        </p>
      </div>
    </li>`;
  }

  mountBlockedBenefitHtml(benefit) {
    return `<li class="benefit-list__item" ${
      benefit.link ? `data-link="${benefit.link}"` : ''
    }>
      <div class="benefit-list__item__icon benefit-list__item__icon--locked">
        <i class="q-icon q-icon-lock-solid"></i>
      </div>

      <div class="benefit-list__item__info">
        <p><strong>${benefit.title}</strong></p>
        <p>${benefit.subtitle}</p>
      </div>
    </li>`;
  }

  mountBenefitHtml(benefit) {
    return `<li class="benefit-list__item" ${
      benefit.link ? `data-link="${benefit.link}"` : ''
    }>
      <div class="benefit-list__item__icon">
        <i class="q-icon q-icon-${benefit.icon}"></i>
      </div>

      <div class="benefit-list__item__info">
        <p><strong>${benefit.title}</strong></p>
        <p>${FREE_ACCESS_TEXT}</p>
      </div>
    </li>`;
  }

  mountEliteFooterLinkHtml() {
    const link = '[portal]/l/conheca-o-plano-ilimitado-elite';
    return `
      <li class="benefit-list__footer-link">
        <a href="javascript:void(0)" data-link="${link}">ver todos os benefícios de ser Elite →</a>
      </li>
    `;
  }

  showBenefitsFloatbutton() {
    let $floatbutton = $('.q-desktop-right-nav .q-benefits-floatbutton');

    if (window.innerWidth <= 768) {
      $floatbutton = $('.q-user-menu--mobile .q-benefits-floatbutton');
    }

    if (!$floatbutton) {
      return;
    }

    $floatbutton.on('click', () => {
      $('html, body').animate({ scrollTop: 0 }, 'fast');

      setTimeout(this.openPanel.bind(this), 500);

      $floatbutton.hide();
    });

    $floatbutton.find('.close-button').on('click', event => {
      event.stopPropagation();

      $floatbutton.hide();
    });

    $floatbutton.removeClass('hidden');
  }

  handleBenefitsWeeklyModal() {
    const consecutiveDays = $('.q-benefits').eq(0).data('consecutive-days');
    const studiedToday = $('.q-benefits').eq(0).data('studied-today');
    const endOfWeek = $('.q-benefits').eq(0).data('end-of-week');

    const showWeeklyModal = endOfWeek && !studiedToday && consecutiveDays >= 6;

    if (!showWeeklyModal) {
      return;
    }

    $('.q-benefits').eq(0).data('studied-today', true);
    this.openWeeklyModal();

    this.$weeklyModal.find('.close-button').on('click', () => {
      this.closeWeeklyModal();
    });

    this.$weeklyModal.find('.actions__cta').on('click', () => {
      this.closeWeeklyModal();

      $('html, body').animate({ scrollTop: 0 }, 'fast');
      setTimeout(this.openPanel.bind(this), 500);
    });

    this.$weeklyModal
      .find('.actions__download')
      .on('click', ({ currentTarget }) => {
        UserTracker.emit('event', {
          eventName: 'streak achievement shared',
          data: {
            place: 'download'
          }
        });

        saveAs(
          currentTarget.dataset.download,
          'Conquista - Semana Inteira de Estudos'
        );
      });
  }

  openWeeklyModal() {
    $('body').addClass('q-no-scroll');
    $('.q-benefits-overlay').show();
    this.$weeklyModal.show();

    UserTracker.emit('event', {
      eventName: 'streak completed week modal opened'
    });
  }

  closeWeeklyModal() {
    $('body').removeClass('q-no-scroll');
    $('.q-benefits-overlay').hide();
    this.$weeklyModal.hide();
  }

  handleShareClick() {
    UserTracker.emit('event', {
      eventName: 'streak achievement shared'
    });
  }

  updateBenefitsStudyDays() {
    const studiedToday = $('.q-benefits').attr('data-studied-today') === 'true';

    if (studiedToday) {
      return;
    }

    Thor.User.used_resources_summary({ user_id: currentUser.id }, {})
      .then(({ day_streak, summary }) => {
        const { number_of_days } = day_streak;
        const { studied_today } = summary;

        this.updateTopbarButton(number_of_days, studied_today);

        $('.q-benefits').attr('data-studied-today', true);
      })
      .catch(error => {
        Rollbar.error(
          '[front] Unable to update experiment_benefits topbar',
          error
        );
      });
  }

  toogleBenefitsContent() {
    if (this.isMainContentVisible) {
      this.showWeeklyInformationContent();
    } else {
      this.showMainContent();
    }
  }

  showWeeklyInformationContent() {
    this.isMainContentVisible = false;

    this.$benefitWeeklyInformation.removeClass('hidden');

    this.$benefitPanelBody.addClass('hidden');
    this.$benefitPanelFooter.addClass('hidden');
  }

  showMainContent() {
    if (this.isMainContentVisible) {
      return;
    }

    this.isMainContentVisible = true;

    this.$benefitWeeklyInformation.addClass('hidden');

    this.$benefitPanelBody.removeClass('hidden');
    this.$benefitPanelFooter.removeClass('hidden');
  }
}

(function ($) {
  $(document).on('turbolinks:load', () => {
    if (gon.flags.topbar_benefits.visible) {
      new ExperimentBenefits();
    }
  });
})(jQuery);

global.ExperimentBenefitsApplication =
  global.ExperimentBenefitsApplication || Application.start();
global.ExperimentBenefitsApplication.register('q-benefits', ExperimentBenefits);
